import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import Title from "../general/title"
import { Pie } from "react-chartjs-2"
import times from "helpers/times"
import colorArray from "helpers/colorArray"
import clone from "clone"
import ImageExport from "components/ImageExport"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import Switch from "react-switch"
import settings from "settings"

class BuilderPerformance extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			times: times(),
			model: {
				contracted: {
					pending: 0,
					delivered: 0,
				},
				builder_takedowns: 0,
				builder_vacant: 0,
				builder_dirt_with_sale: 0,
				models: 0,
				specs: 0,
				developer_held: 0,
				closed: 0,
				completes: 0,
				under_contract: 0,
				total: 0,
				completes_contract: 0,
				uc_under_contract: 0,
				uc_no_contract: 0,
				under_construction: 0,
				completed_unoccupied: 0,
				complete_no_contract: 0,
				contract_no_takedown: {
					delivered: 0,
					pending: 0,
				},
			},
			columns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: `Subdivision | ${settings?.renames?.section || "Section"}`,
					accessor: "sub",
					filterMethod: (f, r) => helpers.tableText(f, r, "sub"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "",
					accessor: "blank",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Developer Contracted to Builder",
					className: "columnGroup",
					columns: [
						{
							Header: "Delivered",
							className: "right",
							accessor: "contracted.delivered",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contracted.delivered"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
						{
							Header: "Pending",
							className: "right",
							accessor: "contracted.pending",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contracted.pending"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
					],
				},
				{
					Header: "",
					accessor: "blank2",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Total",
					accessor: "total",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "total", "0,0"),
				},
				{
					Header: "Sales Ops",
					accessor: "sales_ops",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "sales_ops", "0,0"),
				},
				{
					Header: "Builder Takedowns",
					accessor: "builder_takedowns",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_takedowns
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Models",
					accessor: "models",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.models
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Specs",
					accessor: "specs",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.specs
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Builder VDL",
					accessor: "builder_vacant",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_vacant
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Builder Dirt With Sale",
					accessor: "builder_dirt_with_sale",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_dirt_with_sale
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Developer Held",
					accessor: "developer_held",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.developer_held
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Homes Closed",
					accessor: "closed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.closed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Homes Under Contract",
					accessor: "under_contract",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.under_contract
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Completed Homes",
					accessor: "completes",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "completes", "0,0"),
				},
				{
					Header: "Completed Under Contract",
					accessor: "completes_contract",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "completes_contract", "0,0"),
				},
				{
					Header: "Completed Unoccupied",
					accessor: "completed_unoccupied",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "completed_unoccupied", "0,0"),
				},
				{
					Header: "Completed No Contract",
					accessor: "complete_no_contract",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "complete_no_contract", "0,0"),
				},
				{
					Header: "U/C Under Contract",
					accessor: "uc_under_contract",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "uc_under_contract", "0,0"),
				},
				{
					Header: "U/C No Contract",
					accessor: "uc_no_contract",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "uc_no_contract", "0,0"),
				},
				{
					Header: "Total Under Construction",
					accessor: "under_construction",
					className: "right",
					Footer: (props) => helpers.tableTotals(props, "under_construction", "0,0"),
				},
				{
					Header: "",
					accessor: "blank3",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Contract No Takedown",
					columns: [
						{
							Header: "Delivered",
							className: "right",

							accessor: "contract_no_takedown.delivered",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contract_no_takedown.delivered"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
						{
							Header: "Pending",
							className: "right",
							accessor: "contract_no_takedown.pending",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contract_no_takedown.pending"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
					],
				},
			],
			columnsLotType: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "",
					accessor: "blank",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Developer Contracted to Builder",
					className: "columnGroup",
					columns: [
						{
							Header: "Delivered",
							className: "right",
							accessor: "contracted.delivered",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contracted.delivered"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
						{
							Header: "Pending",
							className: "right",
							accessor: "contracted.pending",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contracted.pending"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
					],
				},
				{
					Header: "",
					accessor: "blank2",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Builder Takedowns",
					accessor: "builder_takedowns",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_takedowns
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Models",
					accessor: "models",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.models
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Specs",
					accessor: "specs",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.specs
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Builder VDL",
					accessor: "builder_vacant",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_vacant
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Builder Dirt With Sale",
					accessor: "builder_dirt_with_sale",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.builder_dirt_with_sale
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Developer Held",
					accessor: "developer_held",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.developer_held
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Homes Closed",
					accessor: "closed",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.closed
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Homes Under Contract",
					accessor: "under_contract",
					className: "right",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.under_contract
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "",
					accessor: "blank3",
					width: 20,
					filterable: false,
					headerClassName: "breaker",
					className: "breaker",
				},
				{
					Header: "Contract No Takedown",
					columns: [
						{
							Header: "Delivered",
							className: "right",

							accessor: "contract_no_takedown.delivered",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contract_no_takedown.delivered"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
						{
							Header: "Pending",
							className: "right",
							accessor: "contract_no_takedown.pending",
							Footer: (props) => {
								let total = 0
								_.forEach(props.data, (v) => {
									total += v["contract_no_takedown.pending"]
								})
								if (typeof total == "number") {
									return total.toLocaleString()
								}
								return total
							},
						},
					],
				},
			],
			inventoryStatus: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Builder",
					accessor: "builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
				},
				{
					Header: "Lot Type",
					accessor: "lot_type",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
				},
				{
					Header: "Builder VDL",
					accessor: "vacant",
					Footer: (props) => helpers.tableTotals(props, "vacant", "0,0"),
				},
				{
					Header: "Models",
					accessor: "models",
					Footer: (props) => helpers.tableTotals(props, "models", "0,0"),
				},
				{
					Header: "Specs",
					accessor: "specs",
					Footer: (props) => helpers.tableTotals(props, "specs", "0,0"),
				},
				{
					Header: "Inv on Website",
					accessor: "website",
					Footer: (props) => helpers.tableTotals(props, "website", "0,0"),
				},
				{
					Header: "Difference",
					accessor: "difference",
					Footer: (props) => helpers.tableTotals(props, "difference", "0,0"),
				},
			],
			active: [],
			all: [],
			substantiallyOnly: false,
		}
	}

	totalProjectInventory = () => {
		// First compile a list of all statuses
		let statuses = {
			"Builder Assigned": 0,
			"Builder Takedowns": 0,
			"Developer Held": 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.closing_date) {
				//return
			}
			if (v.builder && v.takedown_date) {
				statuses["Builder Takedowns"]++
			} else if (v.builder) {
				// active sale - can use just sale_id because if it were closed it would have gotten caught before this
				statuses["Builder Assigned"]++
			} else {
				statuses["Developer Held"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	combinedRemaining = () => {
		// First compile a list of all statuses
		let statuses = {
			Model: 0,
			"Developer Pending-Contracted to Builder": 0,
			"Developer Delivered-Contracted to Builder": 0,
			"Builder Spec": 0,
			"Builder Vacant": 0,
			"Developer Held": 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.sale_id) {
				return
			}
			if (v.model) {
				statuses["Model"]++
				count++
			} else if (v.builder && !v.takedown_date && !v.substantially_complete) {
				// this is the total of builder assigned, have to minus contracts later
				statuses["Developer Pending-Contracted to Builder"]++
				count++
			} else if (v.builder && !v.takedown_date && v.substantially_complete) {
				// this is the total of builder assigned, have to minus contracts later
				statuses["Developer Delivered-Contracted to Builder"]++
				count++
			} else if (v.start_date) {
				statuses["Builder Spec"]++
				count++
			} else if (v.takedown_date && !v.start_date) {
				statuses["Builder Vacant"]++
				count++
			} else if (!v.builder && !v.takedown_date) {
				statuses["Developer Held"]++
				count++
			}
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	totalHomeSales = () => {
		// First compile a list of all statuses
		let statuses = {
			Closed: 0,
			"Contracts On Takedowns": 0,
			"Contracts No Takedown": 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.closing_date) {
				statuses["Closed"]++
				count++
			} else if (v.sale_id && !v.closing_date && v.builder && v.takedown_date) {
				statuses["Contracts On Takedowns"]++
				count++
			} else if (v.sale_id && !v.closing_date && v.builder && !v.takedown_date) {
				statuses["Contracts No Takedown"]++
				count++
			}
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	activeHomeSales = () => {
		// First compile a list of all statuses
		let statuses = {
			"Builder Assigned - Pending": 0,
			"Builder Assigned - Delivered": 0,
			"Contract Under Construction": 0,
			"Contract on Vacant": 0,
			Models: 0,
		}
		let count = 0
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (v.closing_date || !v.sale_id) {
				return
			}
			if (v.model) {
				statuses["Models"]++
			} else if (v.builder && !v.takedown_date && !v.substantially_complete) {
				statuses["Builder Assigned - Pending"]++
			} else if (v.builder && !v.takedown_date && v.substantially_complete) {
				statuses["Builder Assigned - Delivered"]++
			} else if (v.start_date) {
				statuses["Contract Under Construction"]++
			} else if (v.builder && v.takedown_date && !v.start_date) {
				statuses["Contract on Vacant"]++
			}
			count++
		})

		const data = {
			labels: _.keys(statuses),
			datasets: [
				{
					data: _.values(statuses),
					backgroundColor: colorArray,
				},
			],
		}

		const opts = {
			legend: {
				display: true,
				position: "bottom",
			},
		}

		return (
			<>
				<p style={{ margin: 0, fontSize: "14px" }}>Total Lots: {count.toLocaleString()}</p>
				<Pie data={data} options={opts} />
			</>
		)
	}

	buildTable() {
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type) {
				return
			}
			if (!builder) {
				builder = {
					name: "Developer",
				}
			}
			let path = `["${type.name}"]["${builder.name}"]["${v.section_id}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name][v.section_id].sub = `${v.sub_name} | ${v.section_name}`
			store[type.name][builder.name][v.section_id].total++
			if (v.closing_date) {
				store[type.name][builder.name][v.section_id].closed++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date) {
				store[type.name][builder.name][v.section_id].builder_assigned++
			}
			if (v.builder && v.takedown_date) {
				store[type.name][builder.name][v.section_id].builder_takedowns++
			}
			if (helpers.isBuilderVDL(v)) {
				store[type.name][builder.name][v.section_id].builder_vacant++
			}
			if (v.builder && !v.start_date && v.sale_id) {
				store[type.name][builder.name][v.section_id].builder_dirt_with_sale++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contracted.delivered++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contracted.pending++
			}
			if (v.model) {
				store[type.name][builder.name][v.section_id].models++
			}
			if (v.start_date && !v.closing_date && !v.sale_id && !v.model) {
				store[type.name][builder.name][v.section_id].specs++
			}
			if (v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].under_contract++
			}
			if (!v.builder && !v.takedown_date) {
				store[type.name][builder.name][v.section_id].developer_held++
			}
			if (v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contract_no_takedown.delivered++
			}
			if (v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contract_no_takedown.pending++
			}
			if (v.complete_date && v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].completes_contract++
			}
			if (v.complete_date && !v.closing_date) {
				store[type.name][builder.name][v.section_id].completed_unoccupied++
			}
			if (v.complete_date && !v.sale_id) {
				store[type.name][builder.name][v.section_id].complete_no_contract++
			}
			if (v.start_date && !v.complete_date && v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].uc_under_contract++
			}
			if (v.start_date && !v.complete_date && !v.sale_id) {
				store[type.name][builder.name][v.section_id].uc_no_contract++
			}
			if (v.start_date && !v.complete_date) {
				store[type.name][builder.name][v.section_id].under_construction++
			}
		})
		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (sizes, builderName) => {
				_.forEach(sizes, (v) => {
					data.push({
						lot_type: lotType,
						builder: builderName,
						sub: v.sub,
						total: v.total,
						completes: v.completes,
						completes_contract: v.completes_contract,
						completed_unoccupied: v.completed_unoccupied,
						under_construction: v.under_construction,
						uc_no_contract: v.uc_no_contract,
						complete_no_contract: v.complete_no_contract,
						uc_under_contract: v.uc_under_contract,
						contracted: {
							delivered: v.contracted.delivered,
							pending: v.contracted.pending,
						},
						builder_takedowns: v.builder_takedowns,
						models: v.models,
						specs: v.specs,
						developer_held: v.developer_held,
						closed: v.closed,
						under_contract: v.under_contract,
						contract_no_takedown: {
							delivered: v.contract_no_takedown.delivered,
							pending: v.contract_no_takedown.pending,
						},
						builder_vacant: v.builder_vacant,
						builder_dirt_with_sale: v.builder_dirt_with_sale,
					})
				})
			})
		})
		return data
	}

	buildTableLotType() {
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })

			if (!type) {
				return
			}
			if (!builder) {
				builder = {
					name: "Developer",
				}
			}
			let path = `["${type.name}"]["${builder.name}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}

			if (v.closing_date) {
				store[type.name][builder.name].closed++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date) {
				store[type.name][builder.name].builder_assigned++
			}
			if (v.builder && v.takedown_date) {
				store[type.name][builder.name].builder_takedowns++
			}
			if (v.builder && !v.start_date && v.sale_id) {
				store[type.name][builder.name].builder_dirt_with_sale++
			}
			if (helpers.isBuilderVDL(v)) {
				store[type.name][builder.name].builder_vacant++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name].contracted.delivered++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name].contracted.pending++
			}
			if (v.model) {
				store[type.name][builder.name].models++
			}
			if (v.start_date && !v.closing_date && !v.sale_id && !v.model) {
				store[type.name][builder.name].specs++
			}
			if (v.sale_id && !v.closing_date) {
				store[type.name][builder.name].under_contract++
			}
			if (!v.builder && !v.takedown_date) {
				store[type.name][builder.name].developer_held++
			}
			if (v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name].contract_no_takedown.delivered++
			}
			if (v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name].contract_no_takedown.pending++
			}
		})

		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (v, builderName) => {
				data.push({
					lot_type: lotType,
					builder: builderName,
					contracted: {
						delivered: v.contracted.delivered,
						pending: v.contracted.pending,
					},
					builder_takedowns: v.builder_takedowns,
					models: v.models,
					specs: v.specs,
					developer_held: v.developer_held,
					closed: v.closed,
					under_contract: v.under_contract,
					contract_no_takedown: {
						delivered: v.contract_no_takedown.delivered,
						pending: v.contract_no_takedown.pending,
					},
					builder_vacant: v.builder_vacant,
					builder_dirt_with_sale: v.builder_dirt_with_sale,
				})
			})
		})
		return data
	}

	buildInventoryStatus() {
		let store = {}
		let primaryModel = {
			vacant: 0,
			models: 0,
			specs: 0,
			website: 0,
		}
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (this.state.substantiallyOnly && !v.substantially_complete) return
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let community = _.find(this.props.payload.public.properties, { id: v.property })
			if (!type || !community || v.sale_id) {
				return
			}
			if (!builder) {
				builder = {
					name: "Developer",
				}
			}
			let path = `["${community.name}"]["${builder.name}"]["${type.name}"]`
			if (!_.has(store, path)) {
				let model = clone(primaryModel)
				_.setWith(store, path, model, Object)
			}

			if (
				v.start_date > 0 &&
				!v.closing_date &&
				!v.sale_date &&
				(v.lot_status == null || v.lot_status !== "Contract") &&
				!v.model
			) {
				if (!settings.arc && (v.in_feed || v.in_feed_manual)) {
					store[community.name][builder.name][type.name].website++
				} else if (settings.arc) {
					store[community.name][builder.name][type.name].website++
				}
			}

			if (v.model) {
				store[community.name][builder.name][type.name].models++
				return
			}
			if (v.start_date) {
				store[community.name][builder.name][type.name].specs++
				return
			}
			if (!v.start_date && v.takedown_date) {
				store[community.name][builder.name][type.name].vacant++
				return
			}
		})

		let data = []
		_.forEach(store, (builder, community) => {
			_.forEach(builder, (lotType, builderName) => {
				_.forEach(lotType, (v, typeName) => {
					data.push({
						community,
						builder: builderName,
						lot_type: typeName,
						vacant: v.vacant,
						models: v.models,
						specs: v.specs,
						website: v.website,
						difference: v.specs - v.website,
					})
				})
			})
		})
		return data
	}

	buildTableActive() {
		let store = {}
		_.forEach(this.props.payload.exec.lots, (v) => {
			let type = _.find(this.props.payload.public.lot_types, { id: v.lot_type })
			let builder = _.find(this.props.payload.public.builders, { id: v.builder })
			let section = _.find(this.props.payload.public.sections, { id: v.section_id })
			if (!section || !section?.active) {
				return
			} else if (!section?.lot_types[v.lot_type]?.active) {
				return
			}

			if (!type) {
				return
			}
			if (!builder) {
				builder = {
					name: "Developer",
				}
			}
			let path = `["${type.name}"]["${builder.name}"]["${v.section_id}"]`
			if (!_.has(store, path)) {
				let model = clone(this.state.model)
				_.setWith(store, path, model, Object)
			}
			store[type.name][builder.name][v.section_id].sub = `${v.sub_name} | ${v.section_name}`
			store[type.name][builder.name][v.section_id].total++
			if (v.closing_date) {
				store[type.name][builder.name][v.section_id].closed++
			}
			if (v.complete_date) {
				store[type.name][builder.name][v.section_id].completes++
			}
			if (v.complete_date && v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].completes_contract++
			}
			if (v.complete_date && !v.closing_date) {
				store[type.name][builder.name][v.section_id].completed_unoccupied++
			}
			if (v.start_date && !v.complete_date && v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].uc_under_contract++
			}
			if (v.start_date && !v.complete_date && !v.sale_id) {
				store[type.name][builder.name][v.section_id].uc_no_contract++
			}
			if (v.start_date && !v.complete_date) {
				store[type.name][builder.name][v.section_id].under_construction++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contracted.delivered++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contracted.pending++
			}
			if (v.builder && !v.closing_date && !v.sale_id && !v.takedown_date) {
				store[type.name][builder.name][v.section_id].builder_assigned++
			}
			if (v.builder && v.takedown_date) {
				store[type.name][builder.name][v.section_id].builder_takedowns++
			}
			if (v.complete_date && !v.sale_id) {
				store[type.name][builder.name][v.section_id].complete_no_contract++
			}
			if (helpers.isBuilderVDL(v)) {
				store[type.name][builder.name][v.section_id].builder_vacant++
			}
			if (v.builder && !v.start_date && v.sale_id) {
				store[type.name][builder.name][v.section_id].builder_dirt_with_sale++
			}
			if (v.model) {
				store[type.name][builder.name][v.section_id].models++
			}
			if (v.start_date && !v.closing_date && !v.sale_id && !v.model) {
				store[type.name][builder.name][v.section_id].specs++
			}
			if (v.sale_id && !v.closing_date) {
				store[type.name][builder.name][v.section_id].under_contract++
			}
			if (!v.builder && !v.takedown_date) {
				store[type.name][builder.name][v.section_id].developer_held++
			}
			if (v.sale_id && !v.takedown_date && v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contract_no_takedown.delivered++
			}
			if (v.sale_id && !v.takedown_date && !v.substantially_complete) {
				store[type.name][builder.name][v.section_id].contract_no_takedown.pending++
			}
		})
		//console.log(store)

		let data = []
		_.forEach(store, (builder, lotType) => {
			_.forEach(builder, (sizes, builderName) => {
				_.forEach(sizes, (v) => {
					data.push({
						lot_type: lotType,
						builder: builderName,
						sub: v.sub,
						total: v.total,
						completes: v.completes,
						completes_contract: v.completes_contract,
						completed_unoccupied: v.completed_unoccupied,
						under_construction: v.under_construction,
						uc_no_contract: v.uc_no_contract,
						complete_no_contract: v.complete_no_contract,
						uc_under_contract: v.uc_under_contract,
						contracted: {
							delivered: v.contracted.delivered,
							pending: v.contracted.pending,
						},
						builder_takedowns: v.builder_takedowns,
						models: v.models,
						specs: v.specs,
						developer_held: v.developer_held,
						closed: v.closed,
						under_contract: v.under_contract,
						contract_no_takedown: v.contract_no_takedown,
						builder_vacant: v.builder_vacant,
						builder_dirt_with_sale: v.builder_dirt_with_sale,
						sales_ops: v.builder_vacant + v.uc_no_contract + v.complete_no_contract,
					})
				})
			})
		})
		return data
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Builder Performance" showDate={false} />
						<div className="content">
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<ImageExport name="TotalProjectInventory" />
									<h3>Total Project Inventory</h3>
									{this.totalProjectInventory()}
								</div>
								<div className="statBox__box">
									<ImageExport name="CombinedRemainingInventory" />
									<h3>Combined Remaining Inventory</h3>
									{this.combinedRemaining()}
								</div>
							</div>
							<div className="statBox__row statBox__row--double">
								<div className="statBox__box">
									<ImageExport name="TotalHomeSales" />
									<h3>Total Home Sales, Project to Date</h3>
									{this.totalHomeSales()}
								</div>
								<div className="statBox__box">
									<ImageExport name="ActiveHomeSales" />
									<h3>Active Home Sales</h3>
									{this.activeHomeSales()}
								</div>
							</div>
							<h3>Table Breakout - Active {settings?.renames?.section || "Section"}s</h3>
							<p className="text-xs">
								U/C = Under Construction. VDL is any lot owned by a builder without a start date that is
								not sold to a buyer.
							</p>
							<FullTable
								classNames={"small"}
								data={this.buildTableActive()}
								columns={this.state.columns}
								name="builderPerformanceActiveSections"
								title="Builder Performance Active Sections"
								unset={["edit"]}
								pageSize={20}
								rowGroups={{
									field: "lot_type",
									columns: {
										builder_takedowns: 0,
										builder_vacant: 0,
										closed: 0,
										"contract_no_takedown.delivered": 0,
										"contract_no_takedown.pending": 0,
										"contracted.delivered": 0,
										"contracted.pending": 0,
										developer_held: 0,
										models: 0,
										specs: 0,
										under_contract: 0,
									},
									titleInField: "builder",
								}}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>Table Breakout - All {settings?.renames?.section || "Section"}s</h3>
							<FullTable
								data={this.buildTable()}
								classNames={"small"}
								columns={this.state.columns}
								name="builderPerformanceAllSections"
								title="Builder Performance All Section"
								unset={["edit"]}
								pageSize={20}
								rowGroups={{
									field: "lot_type",
									columns: {
										builder_takedowns: 0,
										builder_vacant: 0,
										closed: 0,
										"contract_no_takedown.delivered": 0,
										"contract_no_takedown.pending": 0,
										"contracted.delivered": 0,
										"contracted.pending": 0,
										developer_held: 0,
										models: 0,
										specs: 0,
										under_contract: 0,
									},
									titleInField: "builder",
								}}
							/>
							<h3>Inventory Status</h3>
							<div className="switch" style={{ marginTop: 15 }} onClick={(e) => e.stopPropagation()}>
								<Switch
									onChange={() => this.setState({ substantiallyOnly: !this.state.substantiallyOnly })}
									checked={this.state.substantiallyOnly}
									checkedIcon={false}
									uncheckedIcon={false}
									key={"switch"}
									id={"switch"}
								/>
								<p>
									Showing {this.state.substantiallyOnly ? "Delivered Only Sections" : "All Sections"}
								</p>
							</div>
							<FullTable
								classNames={"small"}
								data={this.buildInventoryStatus()}
								columns={this.state.inventoryStatus}
								name="builderPerformanceInvetoryStatus"
								title="Builder Performance - Inventory Status"
								unset={["edit"]}
								pageSize={20}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h3>By Lot Type</h3>
							<FullTable
								data={this.buildTableLotType()}
								classNames={"small"}
								columns={this.state.columnsLotType}
								name="builderPerformanceLotTypes"
								title="Builder Performance Lot Types"
								unset={["edit"]}
								pageSize={20}
								rowGroups={{
									field: "lot_type",
									columns: {
										builder_takedowns: 0,
										builder_vacant: 0,
										closed: 0,
										"contract_no_takedown.delivered": 0,
										"contract_no_takedown.pending": 0,
										"contracted.delivered": 0,
										"contracted.pending": 0,
										developer_held: 0,
										models: 0,
										specs: 0,
										under_contract: 0,
									},
									titleInField: "builder",
								}}
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderPerformance)
